{
  "main": {
    "cs": {
      "identity": {
        "version": {
          "_cldrVersion": "36"
        },
        "language": "cs"
      },
      "dates": {
        "fields": {
          "era": {
            "displayName": "letopočet"
          },
          "era-short": {
            "displayName": "letop."
          },
          "era-narrow": {
            "displayName": "let."
          },
          "year": {
            "displayName": "rok",
            "relative-type--1": "minulý rok",
            "relative-type-0": "tento rok",
            "relative-type-1": "příští rok",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} rok",
              "relativeTimePattern-count-few": "za {0} roky",
              "relativeTimePattern-count-many": "za {0} roku",
              "relativeTimePattern-count-other": "za {0} let"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} rokem",
              "relativeTimePattern-count-few": "před {0} lety",
              "relativeTimePattern-count-many": "před {0} roku",
              "relativeTimePattern-count-other": "před {0} lety"
            }
          },
          "year-short": {
            "displayName": "r.",
            "relative-type--1": "minulý rok",
            "relative-type-0": "tento rok",
            "relative-type-1": "příští rok",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} r.",
              "relativeTimePattern-count-few": "za {0} r.",
              "relativeTimePattern-count-many": "za {0} r.",
              "relativeTimePattern-count-other": "za {0} l."
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} r.",
              "relativeTimePattern-count-few": "před {0} r.",
              "relativeTimePattern-count-many": "před {0} r.",
              "relativeTimePattern-count-other": "před {0} l."
            }
          },
          "year-narrow": {
            "displayName": "r.",
            "relative-type--1": "minulý rok",
            "relative-type-0": "tento rok",
            "relative-type-1": "příští rok",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} r.",
              "relativeTimePattern-count-few": "za {0} r.",
              "relativeTimePattern-count-many": "za {0} r.",
              "relativeTimePattern-count-other": "za {0} l."
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} r.",
              "relativeTimePattern-count-few": "před {0} r.",
              "relativeTimePattern-count-many": "před {0} r.",
              "relativeTimePattern-count-other": "před {0} l."
            }
          },
          "quarter": {
            "displayName": "čtvrtletí",
            "relative-type--1": "minulé čtvrtletí",
            "relative-type-0": "toto čtvrtletí",
            "relative-type-1": "příští čtvrtletí",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} čtvrtletí",
              "relativeTimePattern-count-few": "za {0} čtvrtletí",
              "relativeTimePattern-count-many": "za {0} čtvrtletí",
              "relativeTimePattern-count-other": "za {0} čtvrtletí"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} čtvrtletím",
              "relativeTimePattern-count-few": "před {0} čtvrtletími",
              "relativeTimePattern-count-many": "před {0} čtvrtletí",
              "relativeTimePattern-count-other": "před {0} čtvrtletími"
            }
          },
          "quarter-short": {
            "displayName": "Q",
            "relative-type--1": "minulé čtvrtletí",
            "relative-type-0": "toto čtvrtletí",
            "relative-type-1": "příští čtvrtletí",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "+{0} Q",
              "relativeTimePattern-count-few": "+{0} Q",
              "relativeTimePattern-count-many": "+{0} Q",
              "relativeTimePattern-count-other": "+{0} Q"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "-{0} Q",
              "relativeTimePattern-count-few": "-{0} Q",
              "relativeTimePattern-count-many": "-{0} Q",
              "relativeTimePattern-count-other": "-{0} Q"
            }
          },
          "quarter-narrow": {
            "displayName": "Q",
            "relative-type--1": "minulé čtvrtletí",
            "relative-type-0": "toto čtvrtletí",
            "relative-type-1": "příští čtvrtletí",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "+{0} Q",
              "relativeTimePattern-count-few": "+{0} Q",
              "relativeTimePattern-count-many": "+{0} Q",
              "relativeTimePattern-count-other": "+{0} Q"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "-{0} Q",
              "relativeTimePattern-count-few": "-{0} Q",
              "relativeTimePattern-count-many": "-{0} Q",
              "relativeTimePattern-count-other": "-{0} Q"
            }
          },
          "month": {
            "displayName": "měsíc",
            "relative-type--1": "minulý měsíc",
            "relative-type-0": "tento měsíc",
            "relative-type-1": "příští měsíc",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} měsíc",
              "relativeTimePattern-count-few": "za {0} měsíce",
              "relativeTimePattern-count-many": "za {0} měsíce",
              "relativeTimePattern-count-other": "za {0} měsíců"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} měsícem",
              "relativeTimePattern-count-few": "před {0} měsíci",
              "relativeTimePattern-count-many": "před {0} měsíce",
              "relativeTimePattern-count-other": "před {0} měsíci"
            }
          },
          "month-short": {
            "displayName": "měs.",
            "relative-type--1": "minulý měs.",
            "relative-type-0": "tento měs.",
            "relative-type-1": "příští měs.",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} měs.",
              "relativeTimePattern-count-few": "za {0} měs.",
              "relativeTimePattern-count-many": "za {0} měs.",
              "relativeTimePattern-count-other": "za {0} měs."
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} měs.",
              "relativeTimePattern-count-few": "před {0} měs.",
              "relativeTimePattern-count-many": "před {0} měs.",
              "relativeTimePattern-count-other": "před {0} měs."
            }
          },
          "month-narrow": {
            "displayName": "měs.",
            "relative-type--1": "minulý měs.",
            "relative-type-0": "tento měs.",
            "relative-type-1": "příští měs.",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} měs.",
              "relativeTimePattern-count-few": "za {0} měs.",
              "relativeTimePattern-count-many": "za {0} měs.",
              "relativeTimePattern-count-other": "za {0} měs."
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} měs.",
              "relativeTimePattern-count-few": "před {0} měs.",
              "relativeTimePattern-count-many": "před {0} měs.",
              "relativeTimePattern-count-other": "před {0} měs."
            }
          },
          "week": {
            "displayName": "týden",
            "relative-type--1": "minulý týden",
            "relative-type-0": "tento týden",
            "relative-type-1": "příští týden",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} týden",
              "relativeTimePattern-count-few": "za {0} týdny",
              "relativeTimePattern-count-many": "za {0} týdne",
              "relativeTimePattern-count-other": "za {0} týdnů"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} týdnem",
              "relativeTimePattern-count-few": "před {0} týdny",
              "relativeTimePattern-count-many": "před {0} týdne",
              "relativeTimePattern-count-other": "před {0} týdny"
            },
            "relativePeriod": "v týdnu {0}"
          },
          "week-short": {
            "displayName": "týd.",
            "relative-type--1": "minulý týd.",
            "relative-type-0": "tento týd.",
            "relative-type-1": "příští týd.",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} týd.",
              "relativeTimePattern-count-few": "za {0} týd.",
              "relativeTimePattern-count-many": "za {0} týd.",
              "relativeTimePattern-count-other": "za {0} týd."
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} týd.",
              "relativeTimePattern-count-few": "před {0} týd.",
              "relativeTimePattern-count-many": "před {0} týd.",
              "relativeTimePattern-count-other": "před {0} týd."
            },
            "relativePeriod": "v týd. {0}"
          },
          "week-narrow": {
            "displayName": "týd.",
            "relative-type--1": "minulý týd.",
            "relative-type-0": "tento týd.",
            "relative-type-1": "příští týd.",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} týd.",
              "relativeTimePattern-count-few": "za {0} týd.",
              "relativeTimePattern-count-many": "za {0} týd.",
              "relativeTimePattern-count-other": "za {0} týd."
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} týd.",
              "relativeTimePattern-count-few": "před {0} týd.",
              "relativeTimePattern-count-many": "před {0} týd.",
              "relativeTimePattern-count-other": "před {0} týd."
            },
            "relativePeriod": "v týd. {0}"
          },
          "weekOfMonth": {
            "displayName": "týden v měsíci"
          },
          "weekOfMonth-short": {
            "displayName": "týd. v m."
          },
          "weekOfMonth-narrow": {
            "displayName": "týd. v m."
          },
          "day": {
            "displayName": "den",
            "relative-type--2": "předevčírem",
            "relative-type--1": "včera",
            "relative-type-0": "dnes",
            "relative-type-1": "zítra",
            "relative-type-2": "pozítří",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} den",
              "relativeTimePattern-count-few": "za {0} dny",
              "relativeTimePattern-count-many": "za {0} dne",
              "relativeTimePattern-count-other": "za {0} dní"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} dnem",
              "relativeTimePattern-count-few": "před {0} dny",
              "relativeTimePattern-count-many": "před {0} dne",
              "relativeTimePattern-count-other": "před {0} dny"
            }
          },
          "day-short": {
            "displayName": "den",
            "relative-type--2": "předevčírem",
            "relative-type--1": "včera",
            "relative-type-0": "dnes",
            "relative-type-1": "zítra",
            "relative-type-2": "pozítří",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} den",
              "relativeTimePattern-count-few": "za {0} dny",
              "relativeTimePattern-count-many": "za {0} dne",
              "relativeTimePattern-count-other": "za {0} dní"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} dnem",
              "relativeTimePattern-count-few": "před {0} dny",
              "relativeTimePattern-count-many": "před {0} dne",
              "relativeTimePattern-count-other": "před {0} dny"
            }
          },
          "day-narrow": {
            "displayName": "den",
            "relative-type--2": "předevčírem",
            "relative-type--1": "včera",
            "relative-type-0": "dnes",
            "relative-type-1": "zítra",
            "relative-type-2": "pozítří",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} den",
              "relativeTimePattern-count-few": "za {0} dny",
              "relativeTimePattern-count-many": "za {0} dne",
              "relativeTimePattern-count-other": "za {0} dní"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} dnem",
              "relativeTimePattern-count-few": "před {0} dny",
              "relativeTimePattern-count-many": "před {0} dne",
              "relativeTimePattern-count-other": "před {0} dny"
            }
          },
          "dayOfYear": {
            "displayName": "den v roce"
          },
          "dayOfYear-short": {
            "displayName": "den v r."
          },
          "dayOfYear-narrow": {
            "displayName": "d. v r."
          },
          "weekday": {
            "displayName": "den v týdnu"
          },
          "weekday-short": {
            "displayName": "den v týd."
          },
          "weekday-narrow": {
            "displayName": "d. v týd."
          },
          "weekdayOfMonth": {
            "displayName": "den týdne v měsíci"
          },
          "weekdayOfMonth-short": {
            "displayName": "den týd. v měs."
          },
          "weekdayOfMonth-narrow": {
            "displayName": "d. týd. v měs."
          },
          "sun": {
            "relative-type--1": "minulou neděli",
            "relative-type-0": "tuto neděli",
            "relative-type-1": "příští neděli",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} neděli",
              "relativeTimePattern-count-few": "za {0} neděle",
              "relativeTimePattern-count-many": "za {0} neděle",
              "relativeTimePattern-count-other": "za {0} nedělí"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} nedělí",
              "relativeTimePattern-count-few": "před {0} nedělemi",
              "relativeTimePattern-count-many": "před {0} neděle",
              "relativeTimePattern-count-other": "před {0} nedělemi"
            }
          },
          "sun-short": {
            "relative-type--1": "minulou neděli",
            "relative-type-0": "tuto neděli",
            "relative-type-1": "příští neděli",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} neděli",
              "relativeTimePattern-count-few": "za {0} neděle",
              "relativeTimePattern-count-many": "za {0} neděle",
              "relativeTimePattern-count-other": "za {0} nedělí"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} nedělí",
              "relativeTimePattern-count-few": "před {0} nedělemi",
              "relativeTimePattern-count-many": "před {0} neděle",
              "relativeTimePattern-count-other": "před {0} nedělemi"
            }
          },
          "sun-narrow": {
            "relative-type--1": "minulou neděli",
            "relative-type-0": "tuto neděli",
            "relative-type-1": "příští neděli",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} neděli",
              "relativeTimePattern-count-few": "za {0} neděle",
              "relativeTimePattern-count-many": "za {0} neděle",
              "relativeTimePattern-count-other": "za {0} nedělí"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} nedělí",
              "relativeTimePattern-count-few": "před {0} nedělemi",
              "relativeTimePattern-count-many": "před {0} neděle",
              "relativeTimePattern-count-other": "před {0} nedělemi"
            }
          },
          "mon": {
            "relative-type--1": "minulé pondělí",
            "relative-type-0": "toto pondělí",
            "relative-type-1": "příští pondělí",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} pondělí",
              "relativeTimePattern-count-few": "za {0} pondělí",
              "relativeTimePattern-count-many": "za {0} pondělí",
              "relativeTimePattern-count-other": "za {0} pondělí"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} pondělím",
              "relativeTimePattern-count-few": "před {0} pondělími",
              "relativeTimePattern-count-many": "před {0} pondělí",
              "relativeTimePattern-count-other": "před {0} pondělími"
            }
          },
          "mon-short": {
            "relative-type--1": "minulé pondělí",
            "relative-type-0": "toto pondělí",
            "relative-type-1": "příští pondělí",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} pondělí",
              "relativeTimePattern-count-few": "za {0} pondělí",
              "relativeTimePattern-count-many": "za {0} pondělí",
              "relativeTimePattern-count-other": "za {0} pondělí"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} pondělím",
              "relativeTimePattern-count-few": "před {0} pondělími",
              "relativeTimePattern-count-many": "před {0} pondělí",
              "relativeTimePattern-count-other": "před {0} pondělími"
            }
          },
          "mon-narrow": {
            "relative-type--1": "minulé pondělí",
            "relative-type-0": "toto pondělí",
            "relative-type-1": "příští pondělí",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} pondělí",
              "relativeTimePattern-count-few": "za {0} pondělí",
              "relativeTimePattern-count-many": "za {0} pondělí",
              "relativeTimePattern-count-other": "za {0} pondělí"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} pondělím",
              "relativeTimePattern-count-few": "před {0} pondělími",
              "relativeTimePattern-count-many": "před {0} pondělí",
              "relativeTimePattern-count-other": "před {0} pondělími"
            }
          },
          "tue": {
            "relative-type--1": "minulé úterý",
            "relative-type-0": "toto úterý",
            "relative-type-1": "příští úterý",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} úterý",
              "relativeTimePattern-count-few": "za {0} úterý",
              "relativeTimePattern-count-many": "za {0} úterý",
              "relativeTimePattern-count-other": "za {0} úterý"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} úterým",
              "relativeTimePattern-count-few": "před {0} úterými",
              "relativeTimePattern-count-many": "před {0} úterý",
              "relativeTimePattern-count-other": "před {0} úterými"
            }
          },
          "tue-short": {
            "relative-type--1": "minulé úterý",
            "relative-type-0": "toto úterý",
            "relative-type-1": "příští úterý",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} úterý",
              "relativeTimePattern-count-few": "za {0} úterý",
              "relativeTimePattern-count-many": "za {0} úterý",
              "relativeTimePattern-count-other": "za {0} úterý"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} úterým",
              "relativeTimePattern-count-few": "před {0} úterými",
              "relativeTimePattern-count-many": "před {0} úterý",
              "relativeTimePattern-count-other": "před {0} úterými"
            }
          },
          "tue-narrow": {
            "relative-type--1": "minulé úterý",
            "relative-type-0": "toto úterý",
            "relative-type-1": "příští úterý",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} úterý",
              "relativeTimePattern-count-few": "za {0} úterý",
              "relativeTimePattern-count-many": "za {0} úterý",
              "relativeTimePattern-count-other": "za {0} úterý"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} úterým",
              "relativeTimePattern-count-few": "před {0} úterými",
              "relativeTimePattern-count-many": "před {0} úterý",
              "relativeTimePattern-count-other": "před {0} úterými"
            }
          },
          "wed": {
            "relative-type--1": "minulou středu",
            "relative-type-0": "tuto středu",
            "relative-type-1": "příští středu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} středu",
              "relativeTimePattern-count-few": "za {0} středy",
              "relativeTimePattern-count-many": "za {0} středy",
              "relativeTimePattern-count-other": "za {0} střed"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} středou",
              "relativeTimePattern-count-few": "před {0} středami",
              "relativeTimePattern-count-many": "před {0} středy",
              "relativeTimePattern-count-other": "před {0} středami"
            }
          },
          "wed-short": {
            "relative-type--1": "minulou středu",
            "relative-type-0": "tuto středu",
            "relative-type-1": "příští středu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} středu",
              "relativeTimePattern-count-few": "za {0} středy",
              "relativeTimePattern-count-many": "za {0} středy",
              "relativeTimePattern-count-other": "za {0} střed"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} středou",
              "relativeTimePattern-count-few": "před {0} středami",
              "relativeTimePattern-count-many": "před {0} středy",
              "relativeTimePattern-count-other": "před {0} středami"
            }
          },
          "wed-narrow": {
            "relative-type--1": "minulou středu",
            "relative-type-0": "tuto středu",
            "relative-type-1": "příští středu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} středu",
              "relativeTimePattern-count-few": "za {0} středy",
              "relativeTimePattern-count-many": "za {0} středy",
              "relativeTimePattern-count-other": "za {0} střed"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} středou",
              "relativeTimePattern-count-few": "před {0} středami",
              "relativeTimePattern-count-many": "před {0} středy",
              "relativeTimePattern-count-other": "před {0} středami"
            }
          },
          "thu": {
            "relative-type--1": "minulý čtvrtek",
            "relative-type-0": "tento čtvrtek",
            "relative-type-1": "příští čtvrtek",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} čtvrtek",
              "relativeTimePattern-count-few": "za {0} čtvrtky",
              "relativeTimePattern-count-many": "za {0} čtvrtku",
              "relativeTimePattern-count-other": "za {0} čtvrtků"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} čtvrtkem",
              "relativeTimePattern-count-few": "před {0} čtvrtky",
              "relativeTimePattern-count-many": "před {0} čtvrtku",
              "relativeTimePattern-count-other": "před {0} čtvrtky"
            }
          },
          "thu-short": {
            "relative-type--1": "minulý čtvrtek",
            "relative-type-0": "tento čtvrtek",
            "relative-type-1": "příští čtvrtek",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} čtvrtek",
              "relativeTimePattern-count-few": "za {0} čtvrtky",
              "relativeTimePattern-count-many": "za {0} čtvrtku",
              "relativeTimePattern-count-other": "za {0} čtvrtků"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} čtvrtkem",
              "relativeTimePattern-count-few": "před {0} čtvrtky",
              "relativeTimePattern-count-many": "před {0} čtvrtku",
              "relativeTimePattern-count-other": "před {0} čtvrtky"
            }
          },
          "thu-narrow": {
            "relative-type--1": "minulý čtvrtek",
            "relative-type-0": "tento čtvrtek",
            "relative-type-1": "příští čtvrtek",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} čtvrtek",
              "relativeTimePattern-count-few": "za {0} čtvrtky",
              "relativeTimePattern-count-many": "za {0} čtvrtku",
              "relativeTimePattern-count-other": "za {0} čtvrtků"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} čtvrtkem",
              "relativeTimePattern-count-few": "před {0} čtvrtky",
              "relativeTimePattern-count-many": "před {0} čtvrtku",
              "relativeTimePattern-count-other": "před {0} čtvrtky"
            }
          },
          "fri": {
            "relative-type--1": "minulý pátek",
            "relative-type-0": "tento pátek",
            "relative-type-1": "příští pátek",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} pátek",
              "relativeTimePattern-count-few": "za {0} pátky",
              "relativeTimePattern-count-many": "za {0} pátku",
              "relativeTimePattern-count-other": "za {0} pátků"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} pátkem",
              "relativeTimePattern-count-few": "před {0} pátky",
              "relativeTimePattern-count-many": "před {0} pátku",
              "relativeTimePattern-count-other": "před {0} pátky"
            }
          },
          "fri-short": {
            "relative-type--1": "minulý pátek",
            "relative-type-0": "tento pátek",
            "relative-type-1": "příští pátek",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} pátek",
              "relativeTimePattern-count-few": "za {0} pátky",
              "relativeTimePattern-count-many": "za {0} pátku",
              "relativeTimePattern-count-other": "za {0} pátků"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} pátkem",
              "relativeTimePattern-count-few": "před {0} pátky",
              "relativeTimePattern-count-many": "před {0} pátku",
              "relativeTimePattern-count-other": "před {0} pátky"
            }
          },
          "fri-narrow": {
            "relative-type--1": "minulý pátek",
            "relative-type-0": "tento pátek",
            "relative-type-1": "příští pátek",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} pátek",
              "relativeTimePattern-count-few": "za {0} pátky",
              "relativeTimePattern-count-many": "za {0} pátku",
              "relativeTimePattern-count-other": "za {0} pátků"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} pátkem",
              "relativeTimePattern-count-few": "před {0} pátky",
              "relativeTimePattern-count-many": "před {0} pátku",
              "relativeTimePattern-count-other": "před {0} pátky"
            }
          },
          "sat": {
            "relative-type--1": "minulou sobotu",
            "relative-type-0": "tuto sobotu",
            "relative-type-1": "příští sobotu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} sobotu",
              "relativeTimePattern-count-few": "za {0} soboty",
              "relativeTimePattern-count-many": "za {0} soboty",
              "relativeTimePattern-count-other": "za {0} sobot"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} sobotou",
              "relativeTimePattern-count-few": "před {0} sobotami",
              "relativeTimePattern-count-many": "před {0} soboty",
              "relativeTimePattern-count-other": "před {0} sobotami"
            }
          },
          "sat-short": {
            "relative-type--1": "minulou sobotu",
            "relative-type-0": "tuto sobotu",
            "relative-type-1": "příští sobotu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} sobotu",
              "relativeTimePattern-count-few": "za {0} soboty",
              "relativeTimePattern-count-many": "za {0} soboty",
              "relativeTimePattern-count-other": "za {0} sobot"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} sobotou",
              "relativeTimePattern-count-few": "před {0} sobotami",
              "relativeTimePattern-count-many": "před {0} soboty",
              "relativeTimePattern-count-other": "před {0} sobotami"
            }
          },
          "sat-narrow": {
            "relative-type--1": "minulou sobotu",
            "relative-type-0": "tuto sobotu",
            "relative-type-1": "příští sobotu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} sobotu",
              "relativeTimePattern-count-few": "za {0} soboty",
              "relativeTimePattern-count-many": "za {0} soboty",
              "relativeTimePattern-count-other": "za {0} sobot"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} sobotou",
              "relativeTimePattern-count-few": "před {0} sobotami",
              "relativeTimePattern-count-many": "před {0} soboty",
              "relativeTimePattern-count-other": "před {0} sobotami"
            }
          },
          "dayperiod-short": {
            "displayName": "část dne"
          },
          "dayperiod": {
            "displayName": "část dne"
          },
          "dayperiod-narrow": {
            "displayName": "část d."
          },
          "hour": {
            "displayName": "hodina",
            "relative-type-0": "tuto hodinu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} hodinu",
              "relativeTimePattern-count-few": "za {0} hodiny",
              "relativeTimePattern-count-many": "za {0} hodiny",
              "relativeTimePattern-count-other": "za {0} hodin"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} hodinou",
              "relativeTimePattern-count-few": "před {0} hodinami",
              "relativeTimePattern-count-many": "před {0} hodiny",
              "relativeTimePattern-count-other": "před {0} hodinami"
            }
          },
          "hour-short": {
            "displayName": "h",
            "relative-type-0": "tuto hodinu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} h",
              "relativeTimePattern-count-few": "za {0} h",
              "relativeTimePattern-count-many": "za {0} h",
              "relativeTimePattern-count-other": "za {0} h"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} h",
              "relativeTimePattern-count-few": "před {0} h",
              "relativeTimePattern-count-many": "před {0} h",
              "relativeTimePattern-count-other": "před {0} h"
            }
          },
          "hour-narrow": {
            "displayName": "h",
            "relative-type-0": "tuto hodinu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} h",
              "relativeTimePattern-count-few": "za {0} h",
              "relativeTimePattern-count-many": "za {0} h",
              "relativeTimePattern-count-other": "za {0} h"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} h",
              "relativeTimePattern-count-few": "před {0} h",
              "relativeTimePattern-count-many": "před {0} h",
              "relativeTimePattern-count-other": "před {0} h"
            }
          },
          "minute": {
            "displayName": "minuta",
            "relative-type-0": "tuto minutu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} minutu",
              "relativeTimePattern-count-few": "za {0} minuty",
              "relativeTimePattern-count-many": "za {0} minuty",
              "relativeTimePattern-count-other": "za {0} minut"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} minutou",
              "relativeTimePattern-count-few": "před {0} minutami",
              "relativeTimePattern-count-many": "před {0} minuty",
              "relativeTimePattern-count-other": "před {0} minutami"
            }
          },
          "minute-short": {
            "displayName": "min",
            "relative-type-0": "tuto minutu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} min",
              "relativeTimePattern-count-few": "za {0} min",
              "relativeTimePattern-count-many": "za {0} min",
              "relativeTimePattern-count-other": "za {0} min"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} min",
              "relativeTimePattern-count-few": "před {0} min",
              "relativeTimePattern-count-many": "před {0} min",
              "relativeTimePattern-count-other": "před {0} min"
            }
          },
          "minute-narrow": {
            "displayName": "min",
            "relative-type-0": "tuto minutu",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} min",
              "relativeTimePattern-count-few": "za {0} min",
              "relativeTimePattern-count-many": "za {0} min",
              "relativeTimePattern-count-other": "za {0} min"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} min",
              "relativeTimePattern-count-few": "před {0} min",
              "relativeTimePattern-count-many": "před {0} min",
              "relativeTimePattern-count-other": "před {0} min"
            }
          },
          "second": {
            "displayName": "sekunda",
            "relative-type-0": "nyní",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} sekundu",
              "relativeTimePattern-count-few": "za {0} sekundy",
              "relativeTimePattern-count-many": "za {0} sekundy",
              "relativeTimePattern-count-other": "za {0} sekund"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} sekundou",
              "relativeTimePattern-count-few": "před {0} sekundami",
              "relativeTimePattern-count-many": "před {0} sekundy",
              "relativeTimePattern-count-other": "před {0} sekundami"
            }
          },
          "second-short": {
            "displayName": "s",
            "relative-type-0": "nyní",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} s",
              "relativeTimePattern-count-few": "za {0} s",
              "relativeTimePattern-count-many": "za {0} s",
              "relativeTimePattern-count-other": "za {0} s"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} s",
              "relativeTimePattern-count-few": "před {0} s",
              "relativeTimePattern-count-many": "před {0} s",
              "relativeTimePattern-count-other": "před {0} s"
            }
          },
          "second-narrow": {
            "displayName": "s",
            "relative-type-0": "nyní",
            "relativeTime-type-future": {
              "relativeTimePattern-count-one": "za {0} s",
              "relativeTimePattern-count-few": "za {0} s",
              "relativeTimePattern-count-many": "za {0} s",
              "relativeTimePattern-count-other": "za {0} s"
            },
            "relativeTime-type-past": {
              "relativeTimePattern-count-one": "před {0} s",
              "relativeTimePattern-count-few": "před {0} s",
              "relativeTimePattern-count-many": "před {0} s",
              "relativeTimePattern-count-other": "před {0} s"
            }
          },
          "zone": {
            "displayName": "časové pásmo"
          },
          "zone-short": {
            "displayName": "čas. pásmo"
          },
          "zone-narrow": {
            "displayName": "pásmo"
          }
        }
      }
    }
  }
}
